// This icon file is generated automatically.
var PFileAddOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.35 3.5L9 .16A.5.5 0 008.64 0H2a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h10a.5.5 0 00.5-.5V3.86a.5.5 0 00-.15-.35zm-1 .6H8.4V1.14l2.94 2.94zm.03 8.78H2.62V1.12h4.72V4.5c0 .36.3.66.66.66h3.38v7.71zM7.5 6.38a.13.13 0 00-.13-.13h-.75a.13.13 0 00-.12.13v1.68H4.81a.13.13 0 00-.12.13v.75c0 .07.05.12.12.12H6.5v1.69c0 .07.06.13.13.13h.75c.06 0 .12-.06.12-.13V9.06h1.69c.07 0 .12-.05.12-.12v-.75a.13.13 0 00-.12-.13H7.5V6.37z", "fill-rule": "nonzero" } }] }, "name": "p-file-add", "theme": "outlined" };
export default PFileAddOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFileAddOutlined.js
// module id = 3376
// module chunks = 0